import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import { api } from "../../services/api";
import { ContainerBackground, ContainerModal, ModalInput } from "./styles";

export const Modal = ({ showModal, setShowModal }) => {
  const [token] = useState(localStorage.getItem("@Kenzie_Hub_USER_TOKEN"));
  const [tech, setTech] = useState([]);

  const schema = yup.object().shape({
    title: yup.string().required("Campo obrigatório!"),
    status: yup.string().required("Campo obrigatório!"),
  });

  const addBtn = ({ title, status }) => {
    const userTech = {
      title,
      status,
    };
    api
      .post("/users/techs", userTech, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setTech([...tech, res.data]);
        toast.success("Tecnologia adicionada com sucesso!");
      })
      .catch((err) => toast.error("Ops! Algo deu errado"));
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  console.log(errors);

  return showModal ? (
    <ContainerBackground>
      <ContainerModal onSubmit={handleSubmit(addBtn)}>
        <header>
          <h1>Cadastrar de Tecnologia</h1>
          <p onClick={() => setShowModal((value) => !value)}>x</p>
        </header>
        <div>
          <p>Nome</p>
          <ModalInput
            type="text"
            placeholder="Digite o nome da sua tecnologia"
            {...register("title")}
          />
          {errors.title && <span>{errors.title.message}</span>}
        </div>
        <div>
          <p>Selecionar status</p>
          <select>
            <option {...register("status")}>Iniciante</option>
            <option {...register("status")}>Intermediário</option>
            <option {...register("status")}>Avançado</option>
          </select>
        </div>
        <button type="submit">Cadastrar Tecnologia</button>
      </ContainerModal>
    </ContainerBackground>
  ) : null;
};
